import { useQuery } from '@tanstack/react-query';
import apiClient from 'api/apiConfig';

export type Workers = string[];

const getWorkersUrl = 'csb/workflows/workers/all';

export const useGetWorkers = () => {
  return useQuery<Workers[]>({
    queryFn: async () => {
      const response = await apiClient.get<Workers[]>(getWorkersUrl);
      return response.data;
    },
    queryKey: ['workers'],
  });
};
